module.exports = __webpack_public_path__ + "img/devto.8721f0de.svg";